import { SVGProps } from './types';

function InfoToolTip(props: SVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <g clipPath="url(#clip0_579_4703)">
        <path
          stroke="#344054"
          strokeLinecap="square"
          strokeWidth="1.458"
          d="M10 13.333V10m0-3.333h.008M18.333 10a8.333 8.333 0 11-16.666 0 8.333 8.333 0 0116.666 0z"
        />
      </g>
      <defs>
        <clipPath id="clip0_579_4703">
          <path fill="#fff" d="M0 0H20V20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export { InfoToolTip };
